<template>
  <div
    :id="chartid"
    :style="styleGroup"
    :chartData="chartData"
    :changePage="changePage"
    :chartName="chartName"
  >
    {{ chartid }}
  </div>
  <!-- <div :id="chartid" :style="{width:chartWidth, height:chartHeight}">{{chartid}}</div> -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "alertModal",
  props: {
    chartId: String,
    styleGroup: Object,
    chartData: Object,
    changePage: Number,
    chartName: String,
  },
  data() {
    return {
      chartid: this.chartId,
      // chartName: this.chartName
    };
  },
  computed: {
    ...mapGetters({}),
  },
  created() {},
  mounted() {
    this.drawChart();
  },
  watch: {
    chartData: {
      handler() {
        this.drawChart();
      },
      //object & array watch change
      deep: true,
    },
    changePage: {
      handler() {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      },
    },
  },
  methods: {
    drawChart: function () {
      let vm = this;
      var type = vm.chartData.senType;
      if (type === "line") {
        vm.drawLineChart();
      } else if (type === "areaLine") {
        vm.drawAreaLineChart();
      } else if (type === "horizonalBar") {
        vm.drawHorizonalBarChart();
      } else if (type === "verticalBar") {
        vm.drawVerticalBarChart();
      } else if (type === "pie") {
        vm.drawPieChart();
      } else if (type === "hollowPie") {
        vm.drawHollowPieChart();
      } else if (type === "scatter") {
        vm.drawScatterChart();
      } else if (type === "gauge") {
        vm.drawGaugeChart();
      } else if (type === "groupVerticalBar") {
        vm.drawGroupVerticalBarChart();
      } else if (type === "piePercent") {
        vm.drawPiePercentChart();
      } else if (type === "VerticalBarLine") {
        vm.drawVerticalBarLineChart();
      } else if (type === "LineVerticalBar") {
        vm.drawLineVerticalBarChart();
      } else if (type === "CPU") {
        vm._drawCPUChart();
      } else if (type === "Machine") {
        vm._drawMachineChart();
      } else if (type === "DISK") {
        vm._drawDISKChart();
      } else if (type === "EntityRAM") {
        vm._drawEntityRAMChart();
      } else if (type === "SwapRAM") {
        vm._drawSwapRAMChart();
      }
    },

    drawLineChart() {
      //折線圖
      let vm = this;

      let getKey = Object.keys(vm.chartData.senData.line);
      let chartTypeTitle = [];
      let chartDataList = [];
      let lineData = [];
      getKey.forEach((dataTitle) => {
        chartTypeTitle.push(dataTitle);

        lineData.push(vm.chartData.senData.line[dataTitle].data);

        if (vm.chartData.senData.line[dataTitle].color != undefined) {
          chartDataList.push({
            name: dataTitle,
            type: "line",
            data: vm.chartData.senData.line[dataTitle].data,
            itemStyle: {
              color: vm.chartData.senData.line[dataTitle].color,
            },
          });
        } else {
          chartDataList.push({
            name: dataTitle,
            type: "line",
            data: vm.chartData.senData.line[dataTitle].data,
          });
        }
      });

      let yAxis_group = {};
      if (vm.chartData.yAxis != undefined) {
        yAxis_group = vm.chartData.yAxis;
      } else {
        yAxis_group = { type: "value" };
      }

      let legend_group = {};
      if (vm.chartData.legend != undefined) {
        legend_group = vm.chartData.legend;
      } else {
        legend_group = {
          x: "right",
          y: "center",
          orient: "vertical",
          data: ["打頭", "輾牙", "熱處理"],
          padding: [0, 35, 0, 0],
        };
      }

      let grid_group = {};
      if (vm.chartData.yAxis != undefined) {
        grid_group = vm.chartData.grid;
      } else {
        grid_group = {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        };
      }

      console.log(chartDataList);
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
          // x: "center",
          // y: "top",
          // textAlign: "left"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: grid_group,
        // {
        //   top: "14%",
        //   left: "3%",
        //   right: "15%",
        //   bottom: "15%",
        //   containLabel: true,
        // },
        legend: legend_group,
        xAxis: {
          type: "category",
          data: vm.chartData.senTime,
        },
        yAxis: yAxis_group,
        series: chartDataList,
        //  {
        //   type: "line",
        //   data: vm.chartData.senData,
        // },
      });
      // vm.reQuerySensor(myChart, index);
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawAreaLineChart() {
      //區塊折線圖
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        // legend: {
        // data: ["a"] //圖標會抓name
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: vm.chartData.senTime,
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        series: [
          {
            // name: "a",
            data: vm.chartData.senData,
            type: "line",
            areaStyle: {},
          },
        ],
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawHorizonalBarChart() {
      //橫式長條圖
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          data: vm.chartData.senTime,
        },
        series: [
          {
            // name: "",
            type: "bar",
            data: vm.chartData.senData,
          },
          //不只一種類型的資料
          // {
          //   name: "test",
          //   type: "bar",
          //   data: [22, 18, 19, 23, 29]
          // }
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawVerticalBarChart() {
      //直式長條圖
      let vm = this;

      let getKey = Object.keys(vm.chartData.senData.bar);
      let chartTypeTitle = [];
      let chartDataList = [];
      let lineData = [];
      getKey.forEach((dataTitle) => {
        chartTypeTitle.push(dataTitle);

        lineData.push(vm.chartData.senData.bar[dataTitle].data);

        if (vm.chartData.senData.bar[dataTitle].color != undefined) {
          chartDataList.push({
            name: dataTitle,
            type: "bar",
            data: vm.chartData.senData.bar[dataTitle].data,
            itemStyle: {
              color: vm.chartData.senData.bar[dataTitle].color,
            },
          });
        } else {
          chartDataList.push({
            name: dataTitle,
            type: "bar",
            data: vm.chartData.senData.bar[dataTitle].data,
          });
        }
      });

      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
        },
        legend: {
          x: "right",
          y: "center",
          orient: "vertical",
          data: ["打頭", "輾牙", "熱處理"],
          padding: [0, 50, 0, 0],
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: {
          top: "14%",
          left: "3%",
          right: "15%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          data: vm.chartData.senTime,
        },
        yAxis: {
          name: "(噸)",
          type: "value",
          boundaryGap: [0, 0.01],
        },
        series: chartDataList,
        // [
        //   {
        //     // name: "",
        //     type: "bar",
        //     data: vm.chartData.senData,
        //   },
        //   //不只一種類型的資料
        //   // {
        //   //   name: "test",
        //   //   type: "bar",
        //   //   data: [22, 18, 19, 23, 29]
        //   // }
        // ],
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawPieChart() {
      //圓餅圖
      let vm = this;
      let sensorValArray = [];
      // let i = 0;
      // vm.chartData.senData.forEach(data => {
      //   sensorValArray.push({
      //     name: vm.chartData.senTime[i],
      //     value: data
      //   });
      //   i++;
      // });
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "right",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        series: [
          {
            data: vm.chartData.senData,
            type: "pie",
            radius: "80%",
            center: ["50%", "60%"],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            silent: true,
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawHollowPieChart() {
      //同心圓餅圖
      let vm = this;
      let sensorValArray = [];
      let i = 0;
      vm.chartData.senData.forEach((data) => {
        sensorValArray.push({
          name: vm.chartData.senTime[i],
          value: data,
        });
        i++;
      });
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
        },
        series: [
          {
            data: sensorValArray,
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawScatterChart() {
      const vm = this;
      let sensorValArray = [];
      for (let i = 0; i < vm.chartData.senTime.length; i++) {
        sensorValArray.push([vm.chartData.senTime[i], vm.chartData.senData[i]]);
      }
      //散點圖
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          // data: ["a"], //圖標會抓name
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          splitNumber: 20,
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        series: [
          {
            // name: "a",
            data: sensorValArray,
            type: "scatter",
            emphasis: {
              label: {
                show: true,
                position: "left",
                color: "blue",
                fontSize: 16,
              },
            },
          },
        ],
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawGaugeChart() {
      //半圓圖
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        // title: {
        //   // text: vm.chartName,
        //   // left: "center"
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        series: [
          {
            type: "gauge",
            min: 0,
            max: 100,
            startAngle: 200,
            endAngle: -20,
            splitNumber: 0,
            pointer: { show: false },
            radius: "50%",
            axisLine: {
              lineStyle: {
                color: [
                  [vm.chartData.senData[0] / 100, "#ffd200"],
                  [1, "#808080"],
                ],
                width: -25,
              },
            },
            axisLabel: {
              color: "transparent",
            },

            splitLine: {
              length: 50,
              lineStyle: {
                width: 0,
                color: "#fff",
              },
            },
            detail: {
              offsetCenter: [0, "90%"],
              textStyle: {
                fontWeight: "bolder",
                color: "#000000",
                fontSize: "30",
              },
              formatter: "{value}%",
            },
            data: [{ value: vm.chartData.senData[0], name: "" }],
          },
        ],
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
      // setInterval(function() {
      //   var test = (Math.random() * 100).toFixed(2) - 0;
      //   var option = {};
      //   myChart.setOption({
      //     series: [
      //       {
      //         axisLine: {
      //           lineStyle: {
      //             color: [
      //               [test / 100, "#ffd200"],
      //               [1, "#808080"]
      //             ]
      //           }
      //         },
      //         data: [{ value: test, name: "" }]
      //       }
      //     ]
      //   });
      //   // myChart.setOption(option);
      // }, 2000);
    },

    drawGroupVerticalBarChart() {
      //直式長條圖
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          // text: vm.chartName,
          // left: "center"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        dataset: {
          source: vm.chartData.senData,
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "4%",
          bottom: "20%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          // data: vm.chartData.senTime
        },
        yAxis: {
          type: "value",
          boundaryGap: [0, 0.1],
        },
        series: [
          { type: "bar", itemStyle: { color: "#427ace" } },
          { type: "bar", itemStyle: { color: "#ff8c1a" } },
          { type: "bar", itemStyle: { color: "#a2a2a2" } },
        ],
        legend: { bottom: 20 },
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawPiePercentChart() {
      //百分比圓餅圖
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        // title: {
        //   // text: vm.chartName,
        //   // left: "center"
        // },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        series: [
          {
            type: "pie",
            radius: ["80%", "60%"],
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "center",
              fontSize: 20,
              color: "#000000",
            },
            color: ["#70AD47", "transparent"],
            data: [
              {
                value: vm.chartData.senData[0],
                name: vm.chartData.senData[0] + "%",
              },
              { value: 100 - vm.chartData.senData[0], name: "" },
            ],
            silent: true,
          },
        ],
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawVerticalBarLineChart() {
      //直式長條圖+折線圖
      let vm = this;

      let getKey = Object.keys(vm.chartData.senData.bar);
      let chartTypeTitle = [];
      let chartDataList = [];
      let lineData = [];
      getKey.forEach((dataTitle) => {
        chartTypeTitle.push(dataTitle);

        lineData.push(vm.chartData.senData.bar[dataTitle].data);

        if (chartDataList.length === 0) {
          chartDataList.push({
            name: dataTitle,
            type: "bar",
            data: vm.chartData.senData.bar[dataTitle].data,
            itemStyle: {
              color: "#4b8c80",
            },
          });
        } else if (chartDataList.length === 1) {
          chartDataList.push({
            name: dataTitle,
            type: "bar",
            data: vm.chartData.senData.bar[dataTitle].data,
            itemStyle: {
              color: "#ff8c1a",
            },
          });
        } else if (chartDataList.length === 2) {
          chartDataList.push({
            name: dataTitle,
            type: "bar",
            data: vm.chartData.senData.bar[dataTitle].data,
            itemStyle: {
              color: "#a2a2a2",
            },
          });
        } else {
          chartDataList.push({
            name: dataTitle,
            type: "bar",
            data: vm.chartData.senData.bar[dataTitle].data,
          });
        }
      });
      let lineDataList = [];
      if (vm.chartData.senData.line.data.length > 0) {
        lineDataList = vm.chartData.senData.line.data;
      } else {
        for (let i = 0; i < lineData.length; i++) {
          for (let j = 0; j < lineData[i].length; j++) {
            if (i === 0) {
              lineDataList.push(lineData[i][j]);
            } else {
              lineDataList[j] = lineDataList[j] + lineData[i][j];
            }
            if (i === lineData.length - 1) {
              lineDataList[j] = (lineDataList[j] / lineData.length).toFixed(2);
            }
          }
        }
      }
      chartTypeTitle.push(vm.chartData.senData.line.name);
      chartDataList.push({
        name: vm.chartData.senData.line.name,
        type: "line",
        data: lineDataList,
        smooth: true,
        itemStyle: {
          color: vm.chartData.senData.line.color,
        },
      });
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        // title: {
        //   text: vm.chartName,
        //   left: "center"
        // },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: chartTypeTitle,
          bottom: 0,
        },
        grid: {
          top: "20%",
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: vm.chartData.senTime,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "單位 " + vm.chartData.senData.unit,
            minInterval: 1,
            // max: 100,
          },
        ],
        series: chartDataList,
      });
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    drawLineVerticalBarChart() {
      //折線圖+直式長條圖
      let vm = this;

      let getChartKey = Object.keys(vm.chartData.senData);
      console.log(getChartKey);
      let chartTypeTitle = [];
      let chartDataList = [];
      let lineData = [];
      getChartKey.forEach((chartKey) => {
        let getKey = Object.keys(vm.chartData.senData[chartKey]);
        getKey.forEach((dataTitle) => {
          chartTypeTitle.push(dataTitle);

          lineData.push(vm.chartData.senData[chartKey][dataTitle].data);

          if (vm.chartData.senData[chartKey][dataTitle].color != undefined) {
            chartDataList.push({
              name: dataTitle,
              type: chartKey,
              data: vm.chartData.senData[chartKey][dataTitle].data,
              itemStyle: {
                color: vm.chartData.senData[chartKey][dataTitle].color,
              },
            });
          } else {
            chartDataList.push({
              name: dataTitle,
              type: chartKey,
              data: vm.chartData.senData[chartKey][dataTitle].data,
            });
          }
        });
      });

      let yAxis_group = {};
      if (vm.chartData.yAxis != undefined) {
        yAxis_group = vm.chartData.yAxis;
      } else {
        yAxis_group = { type: "value" };
      }

      let legend_group = {};
      if (vm.chartData.legend != undefined) {
        legend_group = vm.chartData.legend;
      } else {
        legend_group = {
          // x: "right",
          // y: "center",
          // orient: "vertical",
          // data: ["打頭", "輾牙", "熱處理"],
          // padding: [0, 35, 0, 0],
        };
      }

      let grid_group = {};
      if (vm.chartData.yAxis != undefined) {
        grid_group = vm.chartData.grid;
      } else {
        grid_group = {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        };
      }

      console.log(chartDataList);
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        title: {
          text: vm.chartName,
          left: "center",
          // x: "center",
          // y: "top",
          // textAlign: "left"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        grid: grid_group,
        // {
        //   top: "14%",
        //   left: "3%",
        //   right: "15%",
        //   bottom: "15%",
        //   containLabel: true,
        // },
        legend: legend_group,
        xAxis: {
          type: "category",
          data: vm.chartData.senTime,
        },
        yAxis: yAxis_group,
        series: chartDataList,
        //  {
        //   type: "line",
        //   data: vm.chartData.senData,
        // },
      });
      // vm.reQuerySensor(myChart, index);
      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    _drawCPUChart() {
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      // myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        // legend: {
        //     left: "center",
        //     data: ["usage"],
        // },
        grid: {
          top: "5%",
          left: "1%",
          right: "7%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          name: "%",
          min: 0,
          max: 100,
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          data: vm.chartData.yAxisData,
          axisLabel: {
            formatter: function (value) {
              return value;
            },
            margin: 20,
            rich: {
              value: {
                lineHeight: 30,
                align: "center",
              },
            },
          },
        },
        series: [
          {
            name: "usage",
            type: "bar",
            stack: "total",
            color: "#4B8C80",
            label: {
              show: true,
              position: "right",
            },
            emphasis: {
              focus: "series",
            },
            data: vm.chartData.seriesData,
          },
        ],
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    _drawMachineChart() {
      /*機台狀態*/
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      // myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["機台A", "機台B", "機台C"],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "機台A",
            type: "line",
            smooth: true,
            stack: "总量",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            color: ["#1E457D"],
            data: [120, 132, 101, 300, 90, 230, 210],
          },

          {
            name: "機台B",
            type: "line",
            smooth: true,
            stack: "总量",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            color: ["#4E84BA"],
            data: [320, 210, 301, 110, 390, 330, 380],
          },
          {
            name: "機台C",
            type: "line",
            smooth: true,
            stack: "总量",
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            color: ["#86BBDD"],
            data: [720, 832, 500, 934, 850, 950, 750],
          },
        ],
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    _drawDISKChart() {
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      let this_width = document.getElementById(vm.chartid).offsetWidth - 110;
      // myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        // legend: {
        //   left: "center",
        //   data: ["useful", "last"],
        // },
        grid: {
          top: "5%",
          left: "3%",
          right: "9%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          name: "%",
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        dataset: vm.chartData.dataset,
        yAxis: {
          inverse:true,
          type: "category",
          // data: ["udev", "tmpfs", "/dev/sda", "udev2", "/dev/sda2", "tmpfs2"],
          // data: ["/", "/boot"],
        },
        series: vm.chartData.seriesData,
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },

    _drawEntityRAMChart() {
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      // myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          // formatter: function (params) {
          //     // let colorSpan = color => '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';
          //     let rez = "";
          //     params.forEach((item) => {
          //         // let num = item.value - base;
          //         // if (num >= 1000) {
          //         //     num = format(String(num));
          //         // }
          //         let strItem = "<p>" + item.data + "</p>";
          //         // "<p>" + colorSpan(item.color) + num + "</p>";
          //         rez += strItem;
          //     });
          //     return rez;
          // },
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          data: vm.chartData.legendData,
          padding: [20, 0, 0, 0],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          // name: "MB",
          splitLine: {
            lineStyle: {
              type: "dashed", //網格線
            },
          },
        },
        yAxis: {
          type: "category",
          data: vm.chartData.yAxisData,
        },
        series: vm.chartData.seriesData,
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },
    _drawSwapRAMChart() {
      let vm = this;
      let echarts = require("echarts");
      let myChart = echarts.init(document.getElementById(vm.chartid));
      // myChart.clear(); //clear()可清空series的內容，dispose()可完全清空
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          // formatter: function (params) {
          //     // let colorSpan = color => '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:' + color + '"></span>';
          //     let rez = "";
          //     params.forEach((item) => {
          //         // let num = item.value - base;
          //         // if (num >= 1000) {
          //         //     num = format(String(num));
          //         // }
          //         let strItem = "<p>" + item.data + "</p>";
          //         // "<p>" + colorSpan(item.color) + num + "</p>";
          //         rez += strItem;
          //     });
          //     return rez;
          // },
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          x: "center",
          y: "bottom",
          padding: [0, 0, 20, 0],
          data: vm.chartData.legendData,
        },
        grid: {
          left: "3%",
          right: "4%",
          top: "15%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          // name: "MB",
          splitLine: {
            lineStyle: {
              type: "dashed", //網格線
            },
          },
        },
        yAxis: {
          type: "category",
          data: vm.chartData.yAxisData,
        },
        series: vm.chartData.seriesData,
      });

      window.addEventListener("resize", function () {
        myChart.resize(); //初始化的
      });
    },
  },
};
</script>


<style>
</style>



// WEBPACK FOOTER //
// src/components/chart.vue